import { RouterProvider } from 'react-router-dom'
import router from '@router'
import { AssetsProvider, ThemeProvider } from 'summon-ui'
import { IntlProvider } from 'summon-ui/intl'
import { Notifications } from 'summon-ui/mantine'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import TenantDevTools from '@components/DevTools/TenantDevTools'
import { TENANT_CONFIG } from '@config'
import Tutorial from '@hocs/Tutorial'
import en from '@lang/en.json'
import WagmiWrapper from '@wrappers/WagmiWrapper'

const NOTIFICATIONS_SPACING = '30px'
const NOTIFICATIONS_STYLES = { root: { top: NOTIFICATIONS_SPACING, right: NOTIFICATIONS_SPACING } }
const TWENTY_FOUR_HOURS_IN_MS = 1000 * 60 * 60 * 24

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: TWENTY_FOUR_HOURS_IN_MS
    }
  }
})
const enMessages = { en }

const { name: tenantName, lang: tenantLang, uiTheme: tenantTheme } = TENANT_CONFIG

const App = () => (
  <QueryClientProvider client={queryClient}>
    <WagmiWrapper>
      <AssetsProvider tenant={tenantName}>
        <IntlProvider
          intlConf={{
            currentLang: tenantLang,
            messagesConf: {
              ...enMessages
            }
          }}
        >
          <ThemeProvider uiTheme={tenantTheme}>
            <Notifications position='top-right' zIndex={1000} styles={NOTIFICATIONS_STYLES} />
            <Tutorial>
              <RouterProvider router={router} />
              <ReactQueryDevtools initialIsOpen={false} />
              <TenantDevTools />
            </Tutorial>
          </ThemeProvider>
        </IntlProvider>
      </AssetsProvider>
    </WagmiWrapper>
  </QueryClientProvider>
)

export default App
